<!--
 * @Description:
 * @Date: 2019-03-15 10:04:20
 -->
<template>
  <div>
    <el-dialog
      title="查看详情"
      :visible.sync="dialogVisible"
      width="85%"
      :before-close="handleClose">
      <!-- <TaskRecord :taxCollectionPattern="0" :projectType="1" /> -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkOut">退 出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { project } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { initSearch } from '@/Mixin/initSearch';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect.vue';
import reject from './reject'
import TaskRecord from '@/components/Task/TaskRecord/index.vue';

// import taskRecordHandles from '@/Mixin/taskRecordHandles';

export default {
  props:['dialogVisible'],
  mixins: [pageInation, makeSure],
  data() {
    return {
         options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        value: '',
      ruleForm: {}, // 用户信息
      getList: ()=>new Promise((res,rej)=>{
         res(
             {data:{
                 data:{
                     list:[
                         {
                            name:1
                         }],
                    total:1
                },
         }})
      }), // 获取列表的AJAX
      searchQuery: {
        projectId: this.$route.query.projectId,
        taskMonth: this.$route.query.month,
        projectType: 5,
        statementId:this.$route.query.statementId

      },
      month: this.$route.query.month
    };
  },
  components: {
    dicSelect,
    reject,
    TaskRecord
  },
  computed: {},
  methods: {
    checkStatus(type){
      if(type){
         this.makeSureEvent(checkOutEvent, {}, '<p>您已完成所有任务记录审核</p>', {
        center: true,
        // title:'接收任务',
        dangerouslyUseHTMLString:true,
        confirmButtonText:'签署结算单',
        cancelButtonText:'稍后签署',
        callback:(action,instance)=>{
          if(action === 'cancel'){
             this.acceptDetailShow = true
          }else{
            this.$emit('done')
          }
          console.log(action,instance);
        }
      });
      }else{
         this.makeSureEvent(checkOutEvent, {}, '<p>您已完成所有任务记录审核</p><p>由于您驳回了部分任务记录</p><p>现需要您重新向服务商发起新的结算单</p>', {
        center: true,
        // title:'接收任务',
        dangerouslyUseHTMLString:true,
        confirmButtonText:'发起结算单',
        cancelButtonText:'稍后签署',
        callback:(action,instance)=>{
          if(action === 'cancel'){
             this.acceptDetailShow = true
          }else{
            this.$emit('done')
          }
          console.log(action,instance);
        }
      });
      }
    },
    checkOut(){
      const checkOutEvent = ()=>{
          

      }
      this.makeSureEvent(checkOutEvent, {}, '<p>您尚未完成所有任务记录审核</p><p>是否继续退出?</p>', {
        center: true,
        // title:'接收任务',
        dangerouslyUseHTMLString:true,
        confirmButtonText:'继续退出',
        cancelButtonText:'取消',
        callback:(action,instance)=>{
          if(action === 'cancel'){
             this.acceptDetailShow = true
          }else{
            this.$emit('done')
          }
          console.log(action,instance);
        }
      });
    },
    checkFinished(){
      
    },
    handleClose(done) {
        this.checkOut()
      },
    approve(item){
      const approveEvent = (item)=>{
          console.log(item);
            this.$emit('done')
      }
      this.makeSureEvent(approveEvent, item, '是否确认审核通过？');
    },
    check(item) {
      this.$router.push({
        name: 'surveyRecordDetail',
        query: {
          questionnaireAnswerId: item.questionnaireAnswerId,
          id: this.$route.query.id
        }
      });
    },
    exportEvent() {
      if (this.searchQuery.projectId && this.searchQuery.taskMonth) {
        let queryString = this.$querystring.stringify(this.searchQuery);
        window.open(
          project.taskHzDyRecordDiaoyanPageListExportV2 + '?' + queryString
        );
      } else {
        this.$message.error('请选择条件');
      }
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
  .table-box {
    margin: 0;
  }
</style>
